import { render } from "./MenuRenderer.vue?vue&type=template&id=646e180a&lang=html"
import script from "./MenuRenderer.vue?vue&type=script&lang=js"
export * from "./MenuRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__